import { formaterMontant, type ReglementPiece } from '@admin-pmvb/core'
import { jourMois } from '../libelles'

// Décision « Réglée par la société ou avancée ? » d'une facture de boîte personnelle : ce que
// l'appli a trouvé sur les relevés (`GET /api/pieces/:id/debits`, décision du 13/10/2026), le
// bouton à mettre en avant et ce que fait chaque bouton. Logique pure, testée à part.

type Cote = 'entite' | 'foyer' | 'autre'
type EntiteLue = { nom: string; cote: Cote }
type DebitLu = {
  libelle: string
  montantCts: number
  devise: string
  date: string
  compte: string
  entite: string
  cote: Cote
}

/** Ce que fait chaque réponse (`deciderReglement`, packages/db/src/services/pieces.ts). */
export const CONSEQUENCES_REGLEMENT: Readonly<Record<ReglementPiece, string>> = {
  societe: 'Elle part au cabinet ; son paiement est suivi sur les relevés de la société.',
  avance:
    'Rien au cabinet : la société la rembourse au foyer par une note de frais (page « À refacturer »).',
}

/** « de Flow Design ni du foyer », « de Flow Design, du foyer ni de SC PMVB ». */
function lesComptesDe(entites: readonly EntiteLue[]): string {
  const noms = entites.map((e) => (e.cote === 'foyer' ? 'du foyer' : `de ${e.nom}`))
  if (noms.length <= 1) return noms.join('')
  return `${noms.slice(0, -1).join(', ')} ni ${noms.at(-1)}`
}

/** Rien trouvé : où l'appli a cherché (les comptes que le lecteur voit). */
export function texteAucunDebit(entites: readonly EntiteLue[]): string {
  if (entites.length === 0) return 'Aucun relevé bancaire à consulter pour cette facture.'
  return `Aucun débit trouvé sur les comptes ${lesComptesDe(entites)}.`
}

/** « NUAGE.IO MCC 7372 -26,70 € le 02/08 sur Compte pro (Flow Design) ». */
export function ligneDebit(d: DebitLu): string {
  const libelle = d.libelle.trim().replace(/\s+/g, ' ')
  return `${libelle} ${formaterMontant(d.montantCts, d.devise)} le ${jourMois(d.date)} sur ${d.compte} (${d.entite})`
}

/**
 * La réponse à mettre en avant : l'avance quand les seuls débits trouvés sont sur des comptes du
 * foyer ; sinon la société (son débit trouvé, ou rien de trouvé, comme avant la recherche).
 */
export function reglementRecommande(
  lu: { applicable: boolean; debits: readonly { cote: Cote }[] } | undefined,
): ReglementPiece {
  if (lu?.applicable && lu.debits.length > 0 && lu.debits.every((d) => d.cote === 'foyer'))
    return 'avance'
  return 'societe'
}
